
import { Button } from "@/components/ui/button";
import { Award, Users, Trophy } from 'lucide-react';

interface InitiationWelcomeProps {
  onNext: () => void;
}

const InitiationWelcome = ({ onNext }: InitiationWelcomeProps) => {
  return (
    <div className="text-center space-y-6">
      <div className="relative">
        <img 
          src="/assets/clr_4.png" 
          alt="BroMentum Logo" 
          className="w-32 h-32 mx-auto mb-4"
        />
      </div>
      
      <h2 className="text-2xl font-bold text-tan">Welcome to BroMentum!</h2>
      
      <p className="text-tan-dark">
        Join the brotherhood and become part of the cultural flippening. Complete your initiation to unlock:
      </p>
      
      <div className="space-y-3">
        <div className="flex items-center space-x-3 text-left">
          <Award className="text-tan flex-shrink-0" size={20} />
          <span className="text-tan-dark">Your unique BroCode & rank</span>
        </div>
        <div className="flex items-center space-x-3 text-left">
          <Users className="text-tan flex-shrink-0" size={20} />
          <span className="text-tan-dark">Access to community features</span>
        </div>
        <div className="flex items-center space-x-3 text-left">
          <Trophy className="text-tan flex-shrink-0" size={20} />
          <span className="text-tan-dark">Games, wagers, and rewards</span>
        </div>
      </div>
      
      <Button 
        onClick={onNext}
        className="w-full bg-tan text-navy hover:bg-tan-dark"
      >
        Begin Initiation
      </Button>
    </div>
  );
};

export default InitiationWelcome;
